import { AppThunk } from 'store/types';
import {
  setVendorOrdersDataAction,
  setSearchOrderSettingsAction,
  setVendorOrdersErrorAction,
  setVendorOrdersFetchStatusAction,
} from './reducer';
import { createFetchInProgress, createFetchedSuccess, createFetchedWithError } from 'types/rest/IFetchStatus';
import { eTitleSearchStatus } from 'types/order/title/eTitleSearchStatus';
import { ISearchOrdersSettingsData } from '../../../types/vendorDashboard/ISearchOrdersSettingsData';
import { getOrdersTitleSearchAsync } from '../../../API/vendorDashboard/VendorAPI';
import { Logger } from '../../../ui-toolkit/logging/LoggerService';

export const initVendorOrdersData =
  (settings?: ISearchOrdersSettingsData): AppThunk =>
  async (dispatch, getState) => {
    const fetchStatus = getState().vendorDashboard.orders.ordersFetchStatus;
    const searchSettings = getState().vendorDashboard.orders.searchSettings;
    if (!fetchStatus.fetching && !fetchStatus.fetched) {
      dispatch(getVendorOrdersData(searchSettings.statuses, searchSettings.pageSize, searchSettings.page));
    }
  };

export const getVendorOrdersData =
  (statuses: eTitleSearchStatus[], pageSize: number, page: number, fileNumber?: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(
        setSearchOrderSettingsAction({
          page,
          pageSize,
          statuses,
          fileNumber,
        })
      );
      dispatch(setVendorOrdersErrorAction(undefined));
      dispatch(setVendorOrdersFetchStatusAction(createFetchInProgress()));
      const response = await getOrdersTitleSearchAsync(statuses, pageSize, page, fileNumber);
      dispatch(setVendorOrdersDataAction(response.orders));
      dispatch(setVendorOrdersFetchStatusAction(createFetchedSuccess()));
      if (response.setting.pageSize !== pageSize || response.setting.page !== page) {
        dispatch(setSearchOrderSettingsAction(response.setting));
        Logger.error(`Error getOrdersTitleSearch request`, {
          userPage: page,
          responsePage: response.setting.page,
          userPageSize: pageSize,
          responsePageSize: response.setting.pageSize,
        });
      }
    } catch (e: any) {
      dispatch(setVendorOrdersFetchStatusAction(createFetchedWithError()));
      dispatch(setVendorOrdersErrorAction(e.message));
    }
  };
